import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './layouts/MainLayout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Afiliados from './pages/Afiliados';
import Cooperativas from './pages/Cooperativas';
import Federaciones from './pages/Federaciones';
import Confederaciones from './pages/Confederaciones';

import Wallet from './pages/Wallet';
import Proyectos from './pages/Proyectos';
import Reportes from './pages/Reportes';
import Configuracion from './pages/Configuracion';
import Auditoria from './pages/Auditoria';
import PresentacionNFT from './pages/PresentacionNFT';
import SuperAdminRoute from './components/SuperAdminRoute';
import Comites from './pages/Comites';
import AportesCredito from './pages/AportesCredito';
import Contabilidad from './pages/Contabilidad';
import Nomina from './pages/Nomina';
import Compras from './pages/Compras';
import ActivosFijos from './pages/ActivosFijos';
import FinanciamientoProyectos from './pages/FinanciamientoProyectos';
import AdministracionRed from './pages/AdministracionRed';
import ValidacionCarnet from './pages/ValidacionCarnet';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<Login />} />
            {/* Verificación pública del carnet: la abre el QR, no exige sesión */}
            <Route path="/validar-carnet/:codigo" element={<ValidacionCarnet />} />
            
            {/* Protected Routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="afiliados" element={<Afiliados />} />
              <Route path="cooperativas" element={<Cooperativas />} />
              <Route path="federaciones" element={<Federaciones />} />
              <Route path="confederaciones" element={<Confederaciones />} />

              <Route path="wallet" element={<Wallet />} />
              <Route path="proyectos" element={<Proyectos />} />
              <Route path="reportes" element={<Reportes />} />
              <Route path="configuracion" element={<Configuracion />} />
              <Route path="auditoria" element={<Auditoria />} />
              <Route path="administracion" element={<AdministracionRed />} />
              <Route path="nft-cooperativas" element={<SuperAdminRoute><PresentacionNFT /></SuperAdminRoute>} />
              <Route path="comites" element={<Comites />} />
              <Route path="aportes-credito" element={<AportesCredito />} />
              <Route path="contabilidad" element={<Contabilidad />} />
              <Route path="nomina" element={<Nomina />} />
              <Route path="compras" element={<Compras />} />
              <Route path="activos-fijos" element={<ActivosFijos />} />
              <Route path="financiamiento-proyectos" element={<FinanciamientoProyectos />} />
            </Route>
            
            {/* Catch all - redirect to dashboard */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
